import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
export const siteSelect = {
  title: { de: 'Standort auswählen', en: 'Select a site' },
  subtitle: { de: 'Wählen Sie, welche Farm Sie verwalten möchten.', en: 'Choose which farm to manage.' },
  loadError: {
    de: 'Standorte konnten nicht geladen werden. Bitte erneut versuchen.',
    en: 'Couldn’t load sites. Please retry.',
  },
  noSites: {
    de: 'Für Ihr Konto sind keine Standorte verfügbar.',
    en: 'No sites are available for your account.',
  },
  noSitesAdmin: {
    de: 'Noch keine Standorte. Legen Sie Ihren ersten an, um zu beginnen.',
    en: 'No sites yet. Create your first one to get started.',
  },
  createSite: { de: 'Standort anlegen', en: 'Create a site' },
  site: { de: 'Standort', en: 'Site' },
  pickOne: { de: 'Standort auswählen…', en: 'Select a site…' },
  continue: { de: 'Weiter', en: 'Continue' },
} as const satisfies Namespace;
